import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useAnimation } from 'framer-motion'
import { useInView } from "react-intersection-observer"
import { LendingUnits } from 'components/Landing/enums'
import { Theme } from 'theme'

import {
  Wrapper,
  Title,
  List,
  Item,
  Question,
  Answer,
  ArrowIcon
} from './styled'

// icons
import ArrowSrc from './assets/Arrow.svg'

export default function FaqScreen() {

  const { t, i18n } = useTranslation()
  let items: Array<Object> = t('faq.items', {returnObjects: true})

  const control = useAnimation()
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: LendingUnits.animationShowFooter
  })

  useEffect(() => {
    if (inView) {
      control.start("end");
    }
  }, [control, inView]);

  const infoAnimation = { ...Theme.motion.default, delay: 0.1 }

  return (
    <Wrapper
      variants={Theme.motion.jumpBottom} initial="start" animate={control} transition={infoAnimation}
      ref={ref}
    >
      <Title>{t('faq.title')}</Title>

      <List>

        {items.map((item: any, index) => {
          return (
            <FaqItem
              key={index}
              title={item.title}
              description={item.description}
            />
          )
        })}
      </List>
    </Wrapper>
  )
}

interface ItemProps {
  title: string;
  description: string;
}
export function FaqItem({ title, description }: ItemProps) {

  const [open, setOpen] = useState(false)
  // const [height, setHeight] = useState("0rem")
  // const ref = useRef<HTMLDivElement | null>(null)
  let classes = []
  if (open) {
    classes.push('active')
  }

  // useEffect(() => {
  //   setHeight(ref.current.offsetHeight.toString())
  // }, [])

  return (
    <Item
      onClick={() => setOpen(!open)}
      className={classes.join(' ')}
      // style={{height: (open ? "5rem" : "5rem")}}
    >
      <Question>{title} <ArrowIcon src={ArrowSrc} /></Question>
      <Answer>
        {description}
      </Answer>
    </Item>
  )
}